import { defineMessages } from 'react-intl';
import { SEO } from 'packages/theming/brands';

const seo: SEO = defineMessages({
  pageTitle: {
    id: './src/packages/theming/brands/match/seo:pageTitle',
    description: 'Page title',
    defaultMessage:
      'Match® | {routeTitle} | The Leading Online Dating Site for Singles & Personals',
  },
  pageDescription: {
    id: './src/packages/theming/brands/match/seo:pageDescription',
    description: 'Page Description',
    defaultMessage:
      'Match.com is the number one destination for online dating with more dates, more relationships, & more marriages than any other dating or personals site.',
  },
  pageKeywords: {
    id: './src/packages/theming/brands/match/seo:pageKeywords',
    description: 'Page keywords',
    defaultMessage:
      'online dating, singles, dating, personals, matchmaker, matchmaking, love, match, dating site, match.com, free personals, christian singles, black singles, asian singles, jewish singles, local singles',
  },
});

export default seo;
